module.exports = __webpack_public_path__ + "img/rep-leibold.b0dea1fe.jpg";